import { LocationItemStatus } from 'global-graphql-types'
import { ItemQuestionsFragment } from './types/ItemQuestionsFragment'

type LocationItemQuestionsType =
  ItemQuestionsFragment['locationItemQuestions'][number]

export type FormQuestions = {
  id: number
  text: string
  questionType: 'checkbox' | 'dropdown' | null
  required: boolean | null
  maxAnswers: number | null
  itemAnswers: {
    id: number | null
    text: string | null
    default: boolean
    adjustment: {
      __typename: 'Money'
      cents: number
      formatted: string
    } | null
  }[]
}[]

export const locationQuestionsToQuestionsAdapter = (
  locationQuestions: LocationItemQuestionsType[]
): FormQuestions => {
  return locationQuestions
    .filter((lq) => lq.status === LocationItemStatus.Active)
    .map((lq) => ({
      id: lq.id,
      text: lq.itemQuestion.text,
      questionType: lq.itemQuestion.questionType,
      required: lq.itemQuestion.required,
      maxAnswers: lq.itemQuestion.maxAnswers,
      itemAnswers:
        lq.locationItemAnswers
          ?.filter((la) => la.status === LocationItemStatus.Active)
          .map((la) => ({
            id: la.id,
            text: la.itemAnswer.text,
            default: la.itemAnswer.default,
            adjustment: la.itemAnswer.adjustment
          })) ?? []
    }))
}
